<template>
  <div
    class="card col-md-6 col-lg-4 mb-3 px-0 justify-content-center text-center"
  >
    <div class="card-header text-light bg3">
      <h5 class="card-title mb-0">Twilio Latest</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-2">
          <i class="bi bi-reception-4 icon-size"></i>
        </div>

        <div class="col-8 my-auto mx-sm-1">
          <a href="#"
            ><img
              @click="loadData"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              src="../assets/twilio-logo.png"
              class="img-fluid w-25"
          /></a>
        </div>
        <div class="col-sm-1 my-auto">
          <InfoCard>
            <template v-slot:header>Twilio Latest</template>
            <template v-slot:body>
              This brings back the latest call information for the selected
              number from Twilio
            </template>
          </InfoCard>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Call information</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="twilioData">
            <InfoCard>
              <template v-slot:header>General</template>
              <template v-slot:body>
                General call information including direction and status
                (inbound, completed etc)
              </template>
            </InfoCard>
            <h3 class="text-center">Call</h3>

            <table class="table table-bordered table-success table-striped">
              <thead>
                <tr>
                  <th scope="col" class="text-center">From</th>
                  <th scope="col">To</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{ twilioData.from }}</td>
                  <td>{{ twilioData.to }}</td>
                  <td>{{ twilioData.status }}</td>
                </tr>
              </tbody>
            </table>
            <table class="table table-success table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col">Direction</th>
                  <th scope="col">Start</th>
                  <th scope="col">End</th>
                  <th scope="col">Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ twilioData.direction }}</td>
                  <td>{{ twilioData.start_time }}</td>
                  <td>{{ twilioData.end_time }}</td>
                  <td>{{ twilioData.duration }}</td>
                </tr>
              </tbody>
            </table>
            <InfoCard>
              <template v-slot:header>Events</template>
              <template v-slot:body>
                <div>
                  Event list from twilio's API including calls to Moneypenny
                  webhooks (e.g. call routing).<br />
                  Codes such as 404 and 500 indicate an issue calling back to MP
                  services
                </div>
              </template>
            </InfoCard>
            <h3 class="text-center">Events</h3>
            <div v-for="(event, index) in twilioEvents" :key="index">
              <h4 class="text-center"><i class="bi bi-arrow-right"></i></h4>
              <table class="table table-info table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col">Url</th>
                    <th scope="col">Method</th>
                    <th scope="col">Sid</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ event.request.url }}</td>
                    <td>{{ event.request.method }}</td>
                    <td>{{ event.request.parameters.call_sid }}</td>
                    <td>
                      {{ event.request.parameters.call_status }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 class="text-center"><i class="bi bi-arrow-left"></i></h4>
              <table class="table table-info table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Duration</th>
                    <th scope="col">Content</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ event.response.response_code }}</td>
                    <td>{{ event.response.request_duration }}</td>
                    <td>{{ event.response.content_type }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <InfoCard>
              <template v-slot:header>Notifications</template>
              <template v-slot:body>
                <div>
                  Warnings and errors from twilio e.g. "Number is blacklisted"
                </div>
              </template>
            </InfoCard>
            <h3 class="text-center mt-2" v-if="notifications">Notifications</h3>
            <div v-for="(not, index) in notifications" :key="index">
              <table class="table table-warning table-bordered table-striped">
                <thead>
                  <tr>
                    <th scope="col">Call</th>
                    <th scope="col">Error</th>
                    <th scope="col">Message</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ not.call_sid }}</td>
                    <td>{{ not.error_code }}</td>
                    <td>{{ not.message_text }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <InfoCard>
              <template v-slot:header>Raw data</template>
              <template v-slot:body>
                <div>
                  Full dataset from the twilio event list
                </div>
              </template>
            </InfoCard>
            <button class="btn btn-primary" @click="toggleRaw">
              Toggle raw
            </button>
          </div>
          <div class="row" v-else-if="error">
            <div class="col mt-3">{{ error }}</div>
          </div>
          <div class="text-center" v-else>
            <div class="row justify-content-center align-items-center">
              <div class="col-1"><NewtonsCradle /></div>
            </div>
          </div>
          <pre v-if="twilioData && showRaw">{{ twilioEvents }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import InfoCard from "@/components/InfoCard.vue";
import NewtonsCradle from "@/components/NewtonsCradle.vue";
import { GetLatestCall } from "@/services/number";

const props = defineProps({
  number: {
    type: [String, Number],
  },
});

let twilioData = ref("");
let twilioEvents = ref("");
let notifications = ref("");
let showRaw = ref(false);
let error = ref("");

const loadData = async () => {
  try {
    reset();
    const data = await GetLatestCall(props.number);
    twilioData.value = data.call;
    twilioEvents.value = data.eventModel.events;
    notifications.value = data.notificationModel.notifications;
  } catch (err) {
    if (err.response.status == 404) {
      error.value = `No recent call found for dialled number: ${props.number}`;
    } else {
      error.value = "Sorry, there was a problem retrieving call data";
    }
  }
};

const reset = () => {
  error.value = null;
  twilioData.value = null;
  twilioEvents.value = null;
  notifications.value = null;
};

const toggleRaw = () => {
  showRaw.value = !showRaw.value;
};
</script>

<style></style>
